/**
 * Conversazioni Instagram/Messenger da leggere per i badge globali (menu e icona
 * Messaggi), senza quelle silenziate. Le preferenze (chiave 'meta:<id>' in
 * whatsapp_chat_meta) arrivano da whatsappChatMetaStore, caricate con la lista.
 */
import { useMemo } from 'react';
import { useMetaMessagingStore } from '@/lib/stores/metaMessagingStore';
import { useWhatsAppChatMetaStore } from '@/lib/stores/whatsappChatMetaStore';
import { metaUnreadExcludingMuted } from '@/components/meta-messaging/metaListRules';

export function useMetaUnreadTotal(): number {
  const conversations = useMetaMessagingStore((s) => s.conversations);
  const isUnread = useMetaMessagingStore((s) => s.isUnread);
  // isUnread legge le letture dallo store: senza questa dipendenza il conteggio resterebbe vecchio.
  const reads = useMetaMessagingStore((s) => s.reads);
  const chatMeta = useWhatsAppChatMetaStore((s) => s.chatMeta);
  return useMemo(
    () => metaUnreadExcludingMuted(conversations, isUnread, (key) => chatMeta.get(key)),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [conversations, isUnread, reads, chatMeta],
  );
}
